import type { ReactNode } from 'react';

import * as styles from './LandingButton.css';

interface LandingButtonProps {
  href: string;
  tone?: keyof typeof styles.tone;
  size?: keyof typeof styles.size;
  /** Fill the container's width. */
  block?: boolean;
  target?: '_blank';
  onClick?: () => void;
  children: ReactNode;
}

export const LandingButton = ({
  href,
  tone = 'primary',
  size = 'fixed',
  block = false,
  target,
  onClick,
  children,
}: LandingButtonProps) => (
  <a
    href={href}
    target={target}
    rel={target === '_blank' ? 'noreferrer' : undefined}
    onClick={onClick}
    className={`${styles.button} ${styles.tone[tone]} ${styles.size[size]} ${block ? styles.block : ''}`}
  >
    {children}
  </a>
);
